module.exports = __webpack_public_path__ + "img/sec2_5.f66ff397.png";